import React, { useMemo, useState } from 'react';
import ProductCard from './components/ProductCard'

import './App.css';
import { Container, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const PRODUCT_TYPES = [
    { id: 'all', label: '⭐️Всі товари' },
    { id: 'hhc', label: '🎺HHC Вейп' },
    { id: 'thc', label: '💨THC Вейп' },
    { id: 'edibles', label: '🍬THC мармелад' },
    // { id: 'mushrooms', label: '🍄Грибочки' }
]

export default function Shop({ addProduct, rmProduct, products }) {
    const [activeType, setActiveType] = useState(PRODUCT_TYPES[0].id)

    const visibleProducts = useMemo(() => {
        return products.reduce((acc, product, index) => {
            const matchesType = activeType === 'all' || product.type === activeType
            if (matchesType) {
                acc.push({ product, index })
            }
            return acc
        }, [])
    }, [products, activeType])

    return (
        <Container fluid className="shop-wrapper">
          <div className="product-type">
            <span className="product-type__label">Тип товару</span>
            <div className="product-type-switch">
                {PRODUCT_TYPES.map((type) => (
                    <button
                        key={type.id}
                        type="button"
                        onClick={() => setActiveType(type.id)}
                        className={`product-type-switch__button${type.id === activeType ? ' is-active' : ''}`}
                    >
                        {type.label}
                    </button>
                ))}
            </div>
          </div>
          <Row xs={1} className="product-grid g-3">

            {visibleProducts.map(({ product, index }) => 
              <ProductCard key={product.id} id={index} product={product} addProduct={addProduct} rmProduct={rmProduct} />
            )}

          </Row>
          {visibleProducts.length === 0 && (
            <p className="product-type__empty">Поки що немає товарів у цій категорії.</p>
          )}
        </Container>
    );
}
